import { Text } from 'foundations-components/components/Text';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import ErrorLabel from 'automation-ui-core/components/ErrorLabel';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import UserName from 'automation-ui-references/customer-data/UserName';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import { jsx as _jsx } from "react/jsx-runtime";
const SendInternalSMSActionDetail = ({
  actionMetadata,
  flowObjectTypeId,
  messageLangPath = 'actionDetail'
}) => {
  const renderRecipient = () => {
    const {
      staticTo,
      userId,
      toProperty
    } = actionMetadata;
    if (staticTo) {
      return /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: staticTo
        })
      });
    }
    if (userId) {
      return /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(UserName, {
          id: userId
        })
      });
    }
    if (toProperty) {
      return /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(PropertyName, {
          objectTypeId: flowObjectTypeId,
          propertyName: toProperty
        })
      });
    }
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "recipient"
    });
  };
  const renderBody = () => {
    const {
      body
    } = actionMetadata;
    if (!body) {
      return /*#__PURE__*/_jsx(MissingLabel, {
        type: "body"
      });
    }
    if (flowObjectTypeId) {
      return /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(PersonalizedTextView, {
          propertyTypeId: flowObjectTypeId,
          text: `"${body}"`
        })
      });
    }
    return /*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      children: body
    });
  };
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.send-internal-sms.action-detail",
    options: {
      body: renderBody(),
      recipient: renderRecipient()
    }
  }) : /*#__PURE__*/_jsx(ErrorLabel, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.sunsetted-action.action-detail.content"
    })
  });
};
export default SendInternalSMSActionDetail;